import React from 'react';
import Header from '@/features/customer/auth/components/Header';
import Footer from '@/features/customer/auth/components/Footer';

const CustNotFound: React.FC = () => {
  return (
    <React.Fragment>
      <Header />
      <main className="wrapper">
        <section>
          <div className="inner mtpc-100 mtsp-50">
            <div className="c-al--c">
              <h2 className="c-ttl__01 mbsp-13">404 Not Found</h2>
              <p className="c-txt__01 contact-box__txt">お探しのページが見つかりません。<br />URLに誤りがあるか、お探しのページは移動もしくは削除された可能性があります。</p>
              <a href="/customer/top" className="c-btn__01 c-btn__01--white">TOPページに戻る</a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </React.Fragment>
  );
}

export default CustNotFound;
